var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 92,
    viewBox: "0 0 106 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 92L61.2122 0L106 0L45.7011 92L0 92Z",
    fill: "#B3FF01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBar);
export default __webpack_public_path__ + "static/media/logo-bar.fbbcd0d862e0d5ff466b8a26a0a9e51a.svg";
export { ForwardRef as ReactComponent };